// extracted by mini-css-extract-plugin
export var locationCard = "_pj-0";